import { Pipe, PipeTransform } from '@angular/core';

/**
 * Resolves an app asset path against the webpack public path.
 *
 * Under the SSO single-spa build, `deployUrl` sets the webpack public path to
 * the micro-frontend origin (e.g. http://localhost:4100/). Relative template
 * asset paths ("assets/…", "../../assets/…") would otherwise resolve against
 * the shell's document URL and 404. In the standalone build the public path is
 * "" or "/", so the asset stays relative and resolves via `<base href="/">`.
 *
 * Use for the app's OWN assets referenced as runtime strings in templates/TS.
 * The design-system `<icon>` inlines its SVGs and does NOT need this.
 */

// webpack injects this at runtime; guarded for non-webpack contexts (tests).
declare const __webpack_public_path__: string | undefined;

function publicPath(): string {
  try {
    return typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : '';
  } catch {
    return '';
  }
}

export function assetUrl(path: string | null | undefined): string {
  if (!path) return '';
  // Normalize any leading "./" / "../" segments and a leading slash down to the
  // canonical "assets/…" portion so every call site resolves the same way.
  let p = String(path).replace(/^(?:\.\.?\/)+/, '');
  const idx = p.indexOf('assets/');
  if (idx > 0) p = p.slice(idx);
  p = p.replace(/^\//, '');

  const base = publicPath().replace(/\/$/, '');
  return base ? `${base}/${p}` : p;
}

@Pipe({ name: 'assetUrl', standalone: true })
export class AssetUrlPipe implements PipeTransform {
  transform(path: string | null | undefined): string {
    return assetUrl(path);
  }
}
